import { faRoute } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import GlobalStoreContext from "../../../context/GlobalStoreContext";
import { Dropoff } from "../../../models/Dropoff";
import { GateToDropoffRoute } from "../../../models/GateToDropoffRoute";
import AreaAvatar from "../../Map/AreaAvatar";
import WaypointDirections from "../../Map/WaypointDirections";

interface GateToDropoffRouteSectionProps {
    routes: GateToDropoffRoute[];
    dropoff: Dropoff | null;
}

// Sits between the gate and dropoff sections, since it's the leg of the trip that joins them once inside the jobsite.
const GateToDropoffRouteSection: React.FC<GateToDropoffRouteSectionProps> = ({ routes, dropoff }) => {
    const context = React.useContext(GlobalStoreContext);

    if (routes.length === 0) {
        return null;
    }

    return (
        <div className="p-4 bg-linear-to-r from-plot-blue/5 to-plot-blue/10 rounded-lg mx-4">
            <div className="flex flex-row items-start gap-3 px-4 py-3">
                <FontAwesomeIcon icon={faRoute} className="text-plot-blue shrink-0 mt-1" size="lg" />
                <div className="flex-1 min-w-0 flex flex-col gap-3">
                    <p className="text-xs text-gray-600 font-medium">
                        {routes.length === 1 ? "Approved Route from Gate to Dropoff:" : "Routes from Gate to Dropoff:"}
                    </p>
                    {routes.map((route) => {
                        const routeMapObject = route.getMapObject(context);

                        return (
                            <WaypointDirections
                                key={route.id}
                                route={route}
                                dropoff={dropoff ?? undefined}
                                title={
                                    <div className="flex flex-row items-center text-base font-bold text-gray-900">
                                        {routeMapObject && <AreaAvatar mappable={route} mapObject={routeMapObject} />}
                                        {route.name || "Gate-to-Dropoff Route"}
                                    </div>
                                }
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default GateToDropoffRouteSection;
